import React from 'react';
import ReactDOM from 'react-dom';

import NotFound404 from '../../ui-components/NotFound404';

ReactDOM.render(<div className="layout-404"><NotFound404 layout404/></div>, document.getElementById('react_container'));
